import {
    WojoAccountConfig,
    WojoAccountConfigSchema,
    fetchStoryblokData,
} from "@wojo/storyblok";
import { getStoryblokParams } from "client/hooks";

export const getAccountConfig = async (): Promise<WojoAccountConfig> => {
    const { fullSlug, sbParams } = getStoryblokParams(
        "configurations/web-account-config/web-account-config",
    );

    const { data } = await fetchStoryblokData(fullSlug, sbParams);
    const storyContent: WojoAccountConfig | undefined = data?.story?.content;

    return WojoAccountConfigSchema.parse(storyContent);
};
